import { SIDEBAR_BG, THEME } from "../actions/env.action";

const initialState = {
  activeDir: "ltr",
  activeThemeLayout: "vertical",
  activeTheme: "light",
  activeSidebarType: "full",
  activeLogoBg: "skin2",
  activeNavbarBg: "skin8",
  activeSidebarBg: "skin7",
  activeSidebarPos: "fixed",
  activeHeaderPos: "fixed",
  activeLayout: "full",
};

const settings = (state = initialState, action) => {
  switch (action.type) {
    case SIDEBAR_BG:
      return {
        ...state,
        activeSidebarBg: action.payload,
      };
    case THEME:
      return {
        ...state,
        activeTheme: action.payload,
      };
    default:
      return state;
  }
};

export default settings;
